import { NgModule } from '@angular/core';
import { DefaultWoundCareConnectComponent } from './default-wcc/default-wcc.component';

@NgModule({
  imports: [
    DefaultWoundCareConnectComponent
  ],
  exports: [
    DefaultWoundCareConnectComponent
  ]
})
export class DefaultModule {
}
